import { getOperation } from "utils/api";

const CACHE_KEY = "operation:/account-management/remarks";
const cache = new Map();

const cloneResponse = (response) => {
  if (!response) return response;

  return {
    status: response.status,
    data:
      typeof response.data === "undefined"
        ? response.data
        : JSON.parse(JSON.stringify(response.data)),
  };
};

export const getStatusRemarkOptions = async () => {
  const cachedEntry = cache.get(CACHE_KEY);

  if (cachedEntry?.data) {
    return cloneResponse(cachedEntry.data);
  }

  if (cachedEntry?.promise) {
    const response = await cachedEntry.promise;
    return cloneResponse(response);
  }

  const request = getOperation("/account-management/remarks")
    .then((response) => {
      if (response?.data?.responseCode === "0000") {
        cache.set(CACHE_KEY, { data: cloneResponse(response) });
      } else {
        cache.delete(CACHE_KEY);
      }

      return response;
    })
    .catch(() => {
      cache.delete(CACHE_KEY);
      return null;
    });

  cache.set(CACHE_KEY, { promise: request });

  const response = await request;
  return cloneResponse(response);
};

export const invalidateSuspensionRemarksCache = () => {
  cache.delete(CACHE_KEY);
};
